import React from 'react';
import { PropTypes } from 'prop-types';
import ServiceAuthorizationCreateEvent from './ServiceAuthorizationCreateEvent';
import ServiceAuthorizationStateEvent from './ServiceAuthorizationStateEvent';
import ServiceAuthorizationAssignmentEvent from './ServiceAuthorizationAssignmentEvent';
import ServiceAuthorizationEditEvent from './ServiceAuthorizationEditEvent';

const ServiceAuthorizationTimelineEvent = ({ timelineEvent }) => {
  const changeKeys = timelineEvent.changes.map((event) => event.field_name);
  const isCreateEvent = timelineEvent.action_type === 'create';
  const isStateEvent = changeKeys.includes('state');
  const isAssignedEvent = changeKeys.includes('assignee_id') && changeKeys.length === 1;

  if (isCreateEvent) {
    return <ServiceAuthorizationCreateEvent timelineEvent={timelineEvent} />;
  }
  if (isStateEvent) {
    return <ServiceAuthorizationStateEvent timelineEvent={timelineEvent} />;
  }
  if (isAssignedEvent) {
    return (
      <ServiceAuthorizationAssignmentEvent timelineEvent={timelineEvent} />
    );
  }
  return <ServiceAuthorizationEditEvent timelineEvent={timelineEvent} />;
};

ServiceAuthorizationTimelineEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationTimelineEvent;
